/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_ReplacementInputs */

const en_auto_replacement = /** @type {(inputs: Auto_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Replacement`)
};

const fr_auto_replacement = /** @type {(inputs: Auto_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacement automatique`)
};

const de_auto_replacement = /** @type {(inputs: Auto_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoersatz`)
};

const it_auto_replacement = /** @type {(inputs: Auto_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituzione auto`)
};

const ru_auto_replacement = /** @type {(inputs: Auto_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автозамена`)
};

const es_auto_replacement = /** @type {(inputs: Auto_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazo de Auto`)
};

const zh_cn2_auto_replacement = /** @type {(inputs: Auto_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汽车更换`)
};

const ja_auto_replacement = /** @type {(inputs: Auto_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動交換`)
};

const hi_auto_replacement = /** @type {(inputs: Auto_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो रिप्लेसमेंट`)
};

const pt_pt2_auto_replacement = /** @type {(inputs: Auto_ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituição de automóveis`)
};

/**
* | output |
* | --- |
* | "Auto Replacement" |
*
* @param {Auto_ReplacementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_replacement = /** @type {((inputs?: Auto_ReplacementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_ReplacementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_replacement(inputs)
	if (locale === "de") return de_auto_replacement(inputs)
	if (locale === "it") return it_auto_replacement(inputs)
	if (locale === "ru") return ru_auto_replacement(inputs)
	if (locale === "es") return es_auto_replacement(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_replacement(inputs)
	if (locale === "ja") return ja_auto_replacement(inputs)
	if (locale === "hi") return hi_auto_replacement(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_replacement(inputs)
	return en_auto_replacement(inputs)
});